// @flow
import xhr from "../utils/fetch/xhr";
import {
  getBasePathModularUI,
  getCaptchaPath,
  HTTP_METHODS,
} from "../constants";

type CaptchaInitialResponse = {
  tokenId: string,
  image: string,
};

type CaptchaValidResponse = {
  valid: boolean,
};

type CaptchaInvalidResponse = {
  tokenId: string,
  image: string,
  valid: boolean,
  error: { id: string },
};

type CaptchaResponse = {
  tokenId: string,
  image: string,
  valid: boolean,
  error: { id: string } | null,
};

type CaptchaRequestOptions = {
  origin?: string,
  contextPath?: string,
};

/**
 */
class CaptchaRequest {
  _tokenId: string;
  _image: string;
  _origin: string = "";
  _contextPath: string = getBasePathModularUI();

  /**
   */
  CaptchaRequest(options?: CaptchaRequestOptions) {
    this._origin = options?.origin || "";
    this._contextPath = options?.contextPath || getBasePathModularUI();
  }

  /**
   */
  captchaResponse(
    response:
      | CaptchaInitialResponse
      | CaptchaValidResponse
      | CaptchaInvalidResponse,
  ): CaptchaResponse {
    this._tokenId = response.tokenId ?? this._tokenId;
    this._image = response.image ?? this._image;

    return {
      tokenId: this._tokenId,
      image: this._image,
      valid: response.valid ?? false,
      error: response.error ?? null,
    };
  }

  /**
   * Initiate the captcha request
   */
  init(): Promise<CaptchaResponse> {
    return xhr({
      url: getCaptchaPath(this._contextPath, this._origin),
    }).then((response) => this.captchaResponse(response));
  }

  /**
   * Answer the captcha
   */
  send(answer?: string): Promise<CaptchaResponse> {
    return xhr({
      url: getCaptchaPath(this._contextPath, this._origin),
      method: HTTP_METHODS.POST,
      data: {
        tokenId: this._tokenId ?? "",
        answer: answer ?? "",
      },
    })
      .then((response) => this.captchaResponse(response))
      .catch((error) => this.captchaResponse(error.response));
  }

  /**
   * Reset the captcha and receive a new token and image
   */
  refresh(): Promise<CaptchaResponse> {
    return this.init();
  }
}

export default CaptchaRequest;
